// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  AIMED_SHOT_TALENT: {
    id: 19434,
    name: 'Aimed Shot',
    icon: 'inv_spear_07',
    maxRanks: 1,
    entryIds: [128404],
    definitionIds: [{ id: 133210, specId: 254 }],
    focusCost: 35,
  },
  ALPHA_PREDATOR_TALENT: {
    id: 269737,
    name: 'Alpha Predator',
    icon: 'spell_druid_savagery',
    maxRanks: 1,
    entryIds: [126431],
    definitionIds: [{ id: 131257, specId: 253 }],
  },
  ANIMAL_COMPANION_TALENT: {
    id: 267116,
    name: 'Animal Companion',
    icon: 'ability_hunter_bestialdiscipline',
    maxRanks: 1,
    entryIds: [136679],
    definitionIds: [{ id: 141451, specId: 253 }],
  },
  ARCANE_TALONS_TALENT: {
    id: 1253846,
    name: 'Arcane Talons',
    icon: 'inv_10_specialreagentfoozles_tuskclaw_ice',
    maxRanks: 1,
    entryIds: [117567],
    definitionIds: [{ id: 122579, specId: 255 }],
  },
  ASPECT_OF_THE_BEAST_TALENT: {
    id: 191384,
    name: 'Aspect of the Beast',
    icon: 'ability_deathwing_assualtaspects',
    maxRanks: 1,
    entryIds: [126413],
    definitionIds: [{ id: 131239, specId: 253 }],
  },
  ASPECT_OF_THE_HYDRA_TALENT: {
    id: 470945,
    name: 'Aspect of the Hydra',
    icon: 'inv_111_hunter_ability_doubleknock',
    maxRanks: 1,
    entryIds: [128377],
    definitionIds: [{ id: 133183, specId: 254 }],
  },
  AVIAN_SPECIALIZATION_TALENT: {
    id: 466867,
    name: 'Avian Specialization',
    icon: 'inv_111_hunter_ability_eyesinthesky',
    maxRanks: 1,
    entryIds: [128710],
    definitionIds: [{ id: 133512, specId: 254 }],
  },
  BANSHEES_MARK_TALENT: {
    id: 467902,
    name: "Banshee's Mark",
    icon: 'achievement_leader_sylvanas',
    maxRanks: 1,
    entryIds: [117554],
    definitionIds: [{ id: 122566, specId: 254 }],
  },
  BARBED_SCALES_TALENT: {
    id: 469880,
    name: 'Barbed Scales',
    icon: 'inv_misc_scales_stonygreen',
    maxRanks: 1,
    entryIds: [126415],
    definitionIds: [{ id: 131241, specId: 253 }],
  },
  BARBED_SHOT_TALENT: {
    id: 217200,
    name: 'Barbed Shot',
    icon: 'ability_hunter_barbedshot',
    maxRanks: 1,
    entryIds: [126440],
    definitionIds: [{ id: 131266, specId: 253 }],
  },
  BEAST_CLEAVE_TALENT: {
    id: 115939,
    name: 'Beast Cleave',
    icon: 'ability_hunter_sickem',
    maxRanks: 1,
    entryIds: [126403],
    definitionIds: [{ id: 131229, specId: 253 }],
  },
  BESTIAL_WRATH_TALENT: {
    id: 19574,
    name: 'Bestial Wrath',
    icon: 'ability_druid_ferociousbite',
    maxRanks: 1,
    entryIds: [126402],
    definitionIds: [{ id: 131228, specId: 253 }],
  },
  BETTER_TOGETHER_TALENT: {
    id: 472357,
    name: 'Better Together',
    icon: 'ability_hunter_pathfinding2',
    maxRanks: 1,
    entryIds: [117559],
    definitionIds: [{ id: 122571, specId: 255 }],
  },
  BINDING_SHOT_TALENT: {
    id: 109248,
    name: 'Binding Shot',
    icon: 'spell_shaman_bindelemental',
    maxRanks: 1,
    entryIds: [135711],
    definitionIds: [{ id: 140466, specId: 255 }],
  },
  BLACKROCK_MUNITIONS_TALENT: {
    id: 462036,
    name: 'Blackrock Munitions',
    icon: 'inv_ore_blackrock_nugget',
    maxRanks: 1,
    entryIds: [135688],
    definitionIds: [{ id: 140444, specId: 255 }],
  },
  BLACK_ARROW_BEAST_MASTERY_TALENT: {
    id: 466930,
    name: 'Black Arrow',
    icon: 'inv_ability_darkrangerhunter_blackarrow',
    maxRanks: 1,
    entryIds: [136446],
    definitionIds: [{ id: 141219, specId: 253 }],
    focusCost: 10,
  },
  BLACK_ARROW_MARKSMANSHIP_TALENT: {
    id: 466932,
    name: 'Black Arrow',
    icon: 'inv_ability_darkrangerhunter_blackarrow',
    maxRanks: 1,
    entryIds: [117584],
    definitionIds: [{ id: 122596, specId: 254 }],
  },
  BLEAK_ARROWS_TALENT: {
    id: 467749,
    name: 'Bleak Arrows',
    icon: 'inv_quiver_1h_mawraid_d_01',
    maxRanks: 1,
    entryIds: [117558],
    definitionIds: [{ id: 122570, specId: 254 }],
  },
  BLEAK_POWDER_TALENT: {
    id: 467911,
    name: 'Bleak Powder',
    icon: 'inv_misc_powder_tin',
    maxRanks: 1,
    entryIds: [117571],
    definitionIds: [{ id: 122583, specId: 254 }],
  },
  BLIGHTED_QUIVER_TALENT: {
    id: 1264291,
    name: 'Blighted Quiver',
    icon: 'inv_quiver_1h_sylvanas_d_01',
    maxRanks: 1,
    entryIds: [128238],
    definitionIds: [{ id: 133045, specId: 254 }],
  },
  BLOODSEEKER_TALENT: {
    id: 260248,
    name: 'Bloodseeker',
    icon: 'ability_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [126330],
    definitionIds: [{ id: 131156, specId: 255 }],
  },
  BLOODSHED_TALENT: {
    id: 1272099,
    name: 'Bloodshed',
    icon: 'ability_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [126424],
    definitionIds: [{ id: 131250, specId: 253 }],
  },
  BLOODY_CLAWS_TALENT: {
    id: 385737,
    name: 'Bloody Claws',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [135498],
    definitionIds: [{ id: 140255, specId: 255 }],
  },
  BLOODY_FRENZY_TALENT: {
    id: 407412,
    name: 'Bloody Frenzy',
    icon: 'ability_racial_cannibalize',
    maxRanks: 1,
    entryIds: [126400],
    definitionIds: [{ id: 131226, specId: 253 }],
  },
  BONDING_TALENT: {
    id: 1262442,
    name: 'Bonding',
    icon: 'ability_hunter_beastwithin',
    maxRanks: 1,
    entryIds: [135502],
    definitionIds: [{ id: 140259, specId: 255 }],
  },
  BOOMSTICK_TALENT: {
    id: 1261193,
    name: 'Boomstick',
    icon: 'inv_musket_04',
    maxRanks: 1,
    entryIds: [135515],
    definitionIds: [{ id: 140272, specId: 255 }],
    focusCost: 50,
  },
  BORN_TO_BE_WILD_TALENT: {
    id: 266921,
    name: 'Born To Be Wild',
    icon: 'ability_hunter_aspectoftheviper',
    maxRanks: 2,
    entryIds: [126481],
    definitionIds: [{ id: 131307, specId: 255 }],
  },
  BRUTAL_COMPANION_TALENT: {
    id: 386870,
    name: 'Brutal Companion',
    icon: 'ability_druid_rake',
    maxRanks: 1,
    entryIds: [126412],
    definitionIds: [{ id: 131238, specId: 253 }],
  },
  BULLETSTORM_TALENT: {
    id: 389019,
    name: 'Bulletstorm',
    icon: 'ability_hunter_markedshot',
    maxRanks: 1,
    entryIds: [128384],
    definitionIds: [{ id: 133190, specId: 254 }],
  },
  BULLSEYE_TALENT: {
    id: 204089,
    name: 'Bullseye',
    icon: 'ability_hunter_focusedaim',
    maxRanks: 1,
    entryIds: [128407],
    definitionIds: [{ id: 133213, specId: 254 }],
  },
  CALLING_THE_SHOTS_TALENT: {
    id: 260404,
    name: 'Calling the Shots',
    icon: 'ability_hunter_assassinate',
    maxRanks: 1,
    entryIds: [128379],
    definitionIds: [{ id: 133185, specId: 254 }],
  },
  CAMOUFLAGE_TALENT: {
    id: 199483,
    name: 'Camouflage',
    icon: 'ability_hunter_camouflage',
    maxRanks: 1,
    entryIds: [136676],
    definitionIds: [{ id: 141448, specId: 255 }],
  },
  CANT_MISS_WONT_MISS_TALENT: {
    id: 1253830,
    name: "Can't Miss, Won't Miss",
    icon: 'ability_hunter_aimedshot',
    maxRanks: 1,
    entryIds: [117587],
    definitionIds: [{ id: 122599, specId: 255 }],
  },
  CATLIKE_REFLEXES_TALENT: {
    id: 1258404,
    name: 'Catlike Reflexes',
    icon: 'ability_hunter_catlikereflexes',
    maxRanks: 1,
    entryIds: [135709],
    definitionIds: [{ id: 140464, specId: 255 }],
  },
  COBRA_SENSES_TALENT: {
    id: 378244,
    name: 'Cobra Senses',
    icon: 'ability_hunter_cobrastrikes',
    maxRanks: 1,
    entryIds: [128265],
    definitionIds: [{ id: 133072, specId: 253 }],
  },
  COBRA_SHOT_TALENT: {
    id: 193455,
    name: 'Cobra Shot',
    icon: 'ability_hunter_cobrashot',
    maxRanks: 1,
    entryIds: [126416],
    definitionIds: [{ id: 131242, specId: 253 }],
    focusCost: 35,
  },
  COLD_FEET_TALENT: {
    id: 1268671,
    name: 'Cold Feet',
    icon: 'ability_mage_icyfeet',
    maxRanks: 1,
    entryIds: [136672],
    definitionIds: [{ id: 141444, specId: 255 }],
  },
  COMBAT_EXPERIENCE_TALENT: {
    id: 1268871,
    name: 'Combat Experience',
    icon: 'ability_hunter_combatexperience',
    maxRanks: 1,
    entryIds: [136677],
    definitionIds: [{ id: 141449, specId: 255 }],
  },
  CONCUSSIVE_SHOT_TALENT: {
    id: 5116,
    name: 'Concussive Shot',
    icon: 'spell_frost_stun',
    maxRanks: 1,
    entryIds: [126471],
    definitionIds: [{ id: 131297, specId: 255 }],
  },
  CONDITIONING_TALENT: {
    id: 1253887,
    name: 'Conditioning',
    icon: 'ability_racial_runningwild',
    maxRanks: 1,
    entryIds: [117577],
    definitionIds: [{ id: 122589, specId: 255 }],
  },
  CORPSECALLER_TALENT: {
    id: 1264289,
    name: 'Corpsecaller',
    icon: 'ability_fiegndead',
    maxRanks: 1,
    entryIds: [136059],
    definitionIds: [{ id: 140814, specId: 254 }],
  },
  COUNTER_SHOT_TALENT: {
    id: 147362,
    name: 'Counter Shot',
    icon: 'inv_ammo_arrow_03',
    maxRanks: 1,
    entryIds: [126352, 126466],
    definitionIds: [
      { id: 131178, specId: 253 },
      { id: 131292, specId: 254 },
    ],
  },
  CRITICAL_PRECISION_TALENT: {
    id: 1277572,
    name: 'Critical Precision',
    icon: 'ability_impalingbolt',
    maxRanks: 1,
    entryIds: [128375],
    definitionIds: [{ id: 133181, specId: 254 }],
  },
  CUNNING_TALENT: {
    id: 474440,
    name: 'Cunning',
    icon: 'ability_eyeoftheowl',
    maxRanks: 1,
    entryIds: [128411],
    definitionIds: [{ id: 133217, specId: 254 }],
  },
  DARK_CHAINS_TALENT: {
    id: 430712,
    name: 'Dark Chains',
    icon: 'inv_belt_44c',
    maxRanks: 1,
    entryIds: [117557],
    definitionIds: [{ id: 122569, specId: 254 }],
  },
  DEADEYE_TALENT: {
    id: 321460,
    name: 'Deadeye',
    icon: 'spell_hunter_focusingshot',
    maxRanks: 1,
    entryIds: [128715],
    definitionIds: [{ id: 133517, specId: 254 }],
  },
  DEATHBLOW_TALENT: {
    id: 343248,
    name: 'Deathblow',
    icon: 'ability_hunter_runningshot',
    maxRanks: 1,
    entryIds: [135714],
    definitionIds: [{ id: 140469, specId: 254 }],
  },
  DEVILSAUR_TRANQUILIZER_TALENT: {
    id: 459991,
    name: 'Devilsaur Tranquilizer',
    icon: 'ability_hunter_pet_devilsaur',
    maxRanks: 1,
    entryIds: [126479],
    definitionIds: [{ id: 131305, specId: 255 }],
  },
  DIRE_BEAST_TALENT: {
    id: 120679,
    name: 'Dire Beast',
    icon: 'ability_hunter_longevity',
    maxRanks: 1,
    entryIds: [126439],
    definitionIds: [{ id: 131265, specId: 253 }],
  },
  DIRE_CLEAVE_TALENT: {
    id: 1217524,
    name: 'Dire Cleave',
    icon: 'ability_physical_taunt',
    maxRanks: 1,
    entryIds: [126398],
    definitionIds: [{ id: 131224, specId: 253 }],
  },
  DIRE_COMMAND_TALENT: {
    id: 378743,
    name: 'Dire Command',
    icon: 'ability_hunter_ferociousinspiration',
    maxRanks: 1,
    entryIds: [126427],
    definitionIds: [{ id: 131253, specId: 253 }],
  },
  DIRE_FRENZY_TALENT: {
    id: 385810,
    name: 'Dire Frenzy',
    icon: 'ability_hunter_huntervswild',
    maxRanks: 2,
    entryIds: [126430],
    definitionIds: [{ id: 131256, specId: 253 }],
  },
  DIRE_SUMMONS_TALENT: {
    id: 472352,
    name: 'Dire Summons',
    icon: 'inv_misc_horn_01',
    maxRanks: 1,
    entryIds: [117589],
    definitionIds: [{ id: 122601, specId: 255 }],
  },
  DISRUPTIVE_ROUNDS_TALENT: {
    id: 343244,
    name: 'Disruptive Rounds',
    icon: 'hunter_pvp_vipersting',
    maxRanks: 1,
    entryIds: [126459],
    definitionIds: [{ id: 131285, specId: 255 }],
  },
  DONT_LOOK_BACK_TALENT: {
    id: 450373,
    name: "Don't Look Back",
    icon: 'ability_racial_forceshield',
    maxRanks: 1,
    entryIds: [117586],
    definitionIds: [{ id: 122598, specId: 255 }],
  },
  DOUBLE_TAP_TALENT: {
    id: 473370,
    name: 'Double Tap',
    icon: 'ability_hunter_crossfire',
    maxRanks: 1,
    entryIds: [136232],
    definitionIds: [{ id: 141005, specId: 254 }],
  },
  EAGLES_ACCURACY_TALENT: {
    id: 473369,
    name: "Eagle's Accuracy",
    icon: 'ability_hunter_silenthunter',
    maxRanks: 2,
    entryIds: [128395],
    definitionIds: [{ id: 133201, specId: 254 }],
  },
  EBON_BOWSTRING_TALENT: {
    id: 467897,
    name: 'Ebon Bowstring',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color4',
    maxRanks: 1,
    entryIds: [117583],
    definitionIds: [{ id: 122595, specId: 254 }],
  },
  EMERGENCY_SALVE_TALENT: {
    id: 459517,
    name: 'Emergency Salve',
    icon: 'inv_potion_29',
    maxRanks: 1,
    entryIds: [126452],
    definitionIds: [{ id: 131278, specId: 255 }],
  },
  EXPLOSIVES_EXPERT_TALENT: {
    id: 378937,
    name: 'Explosives Expert',
    icon: 'inv_misc_bomb_05',
    maxRanks: 2,
    entryIds: [126341],
    definitionIds: [{ id: 131167, specId: 255 }],
  },
  EXPLOSIVE_SHOT_TALENT: {
    id: 212431,
    name: 'Explosive Shot',
    icon: 'ability_hunter_explosiveshot',
    maxRanks: 1,
    entryIds: [137378],
    definitionIds: [{ id: 142138, specId: 254 }],
    focusCost: 20,
  },
  FEATHERED_FRENZY_TALENT: {
    id: 470943,
    name: 'Feathered Frenzy',
    icon: 'inv_111_hunter_ability_featheredfrenzy',
    maxRanks: 1,
    entryIds: [128406],
    definitionIds: [{ id: 133212, specId: 254 }],
  },
  FLAMEBREAK_TALENT: {
    id: 1253176,
    name: 'Flamebreak',
    icon: 'inv_wildfirebomb_blood',
    maxRanks: 1,
    entryIds: [135493],
    definitionIds: [{ id: 140250, specId: 255 }],
  },
  FLAMEFANG_PITCH_TALENT: {
    id: 1251592,
    name: 'Flamefang Pitch',
    icon: 'inv_10_blacksmithing_craftedoptional_blacksmithdye_fire',
    maxRanks: 1,
    entryIds: [126311],
    definitionIds: [{ id: 131137, specId: 255 }],
    focusCost: 20,
  },
  FLANKED_TALENT: {
    id: 1256938,
    name: 'Flanked',
    icon: 'ability_hunter_invigeration',
    maxRanks: 1,
    entryIds: [136682],
    definitionIds: [{ id: 141454, specId: 255 }],
  },
  FLANKERS_ADVANTAGE_TALENT: {
    id: 459964,
    name: "Flanker's Advantage",
    icon: 'ability_hunter_beastmastery',
    maxRanks: 1,
    entryIds: [126339],
    definitionIds: [{ id: 131165, specId: 255 }],
  },
  FOCUSED_AIM_TALENT: {
    id: 378767,
    name: 'Focused Aim',
    icon: 'inv_engineering_snipingscope',
    maxRanks: 1,
    entryIds: [128716],
    definitionIds: [{ id: 133518, specId: 254 }],
  },
  FOCUS_FIRE_TALENT: {
    id: 1277546,
    name: 'Focus Fire',
    icon: 'ability_hunter_focusfire',
    maxRanks: 1,
    entryIds: [128401],
    definitionIds: [{ id: 133207, specId: 254 }],
  },
  FRENZY_TALENT: {
    id: 1264934,
    name: 'Frenzy',
    icon: 'ability_druid_kingofthejungle',
    maxRanks: 2,
    entryIds: [126397],
    definitionIds: [{ id: 131223, specId: 253 }],
  },
  FURY_OF_THE_WYVERN_TALENT: {
    id: 472550,
    name: 'Fury of the Wyvern',
    icon: 'spell_druid_feralchargecat',
    maxRanks: 1,
    entryIds: [117581],
    definitionIds: [{ id: 122593, specId: 255 }],
  },
  GO_FOR_THE_THROAT_TALENT: {
    id: 459550,
    name: 'Go for the Throat',
    icon: 'ability_hunter_goforthethroat',
    maxRanks: 1,
    entryIds: [126419],
    definitionIds: [{ id: 131245, specId: 253 }],
  },
  GRENADE_JUGGLER_TALENT: {
    id: 459843,
    name: 'Grenade Juggler',
    icon: 'inv_misc_mohawkgrenade',
    maxRanks: 1,
    entryIds: [135508],
    definitionIds: [{ id: 140265, specId: 255 }],
  },
  GUARDIANS_HIDE_TALENT: {
    id: 1272094,
    name: "Guardian's Hide",
    icon: 'spell_druid_bristlingfur',
    maxRanks: 1,
    entryIds: [136685],
    definitionIds: [{ id: 141457, specId: 255 }],
  },
  GUERRILLA_TACTICS_TALENT: {
    id: 264332,
    name: 'Guerrilla Tactics',
    icon: 'spell_mage_flameorb',
    maxRanks: 1,
    entryIds: [126345],
    definitionIds: [{ id: 131171, specId: 255 }],
  },
  GUTTURAL_ROAR_TALENT: {
    id: 1258509,
    name: 'Guttural Roar',
    icon: 'ability_druid_challangingroar',
    maxRanks: 1,
    entryIds: [135704],
    definitionIds: [{ id: 140459, specId: 255 }],
  },
  HEADSHOT_TALENT: {
    id: 471363,
    name: 'Headshot',
    icon: 'ability_marksmanship',
    maxRanks: 1,
    entryIds: [128394],
    definitionIds: [{ id: 133200, specId: 254 }],
  },
  HEART_OF_THE_PACK_TALENT: {
    id: 1265052,
    name: 'Heart of the Pack',
    icon: 'ability_druid_berserk',
    maxRanks: 1,
    entryIds: [126422],
    definitionIds: [{ id: 131248, specId: 253 }],
  },
  HOGSTRIDER_TALENT: {
    id: 472639,
    name: 'Hogstrider',
    icon: 'inv_misc_boarshead',
    maxRanks: 1,
    entryIds: [117585],
    definitionIds: [{ id: 122597, specId: 255 }],
  },
  HOOF_AND_BLADE_TALENT: {
    id: 1264797,
    name: 'Hoof and Blade',
    icon: 'ability_hunter_beastwithin',
    maxRanks: 1,
    entryIds: [136062],
    definitionIds: [{ id: 140817, specId: 255 }],
  },
  HORSEHAIR_TETHER_TALENT: {
    id: 472729,
    name: 'Horsehair Tether',
    icon: 'inv_misc_rope_01',
    maxRanks: 1,
    entryIds: [136670],
    definitionIds: [{ id: 141442, specId: 255 }],
  },
  HOWL_OF_THE_PACK_LEADER_TALENT: {
    id: 471876,
    name: 'Howl of the Pack Leader',
    icon: 'inv_ability_packleaderhunter_vicioushunt',
    maxRanks: 1,
    entryIds: [117588],
    definitionIds: [{ id: 122600, specId: 255 }],
  },
  HUNTERS_AVOIDANCE_TALENT: {
    id: 384799,
    name: "Hunter's Avoidance",
    icon: 'rogue_burstofspeed',
    maxRanks: 1,
    entryIds: [126489],
    definitionIds: [{ id: 131315, specId: 255 }],
  },
  HUNTMASTERS_CALL_TALENT: {
    id: 459730,
    name: "Huntmaster's Call",
    icon: 'spell_hunter_lonewolf',
    maxRanks: 1,
    entryIds: [132189],
    definitionIds: [{ id: 136990, specId: 253 }],
  },
  IMPROVED_ASPECT_OF_THE_CHEETAH_TALENT: {
    id: 1258407,
    name: 'Improved Aspect of the Cheetah',
    icon: 'ability_mount_jungletiger',
    maxRanks: 1,
    entryIds: [135708],
    definitionIds: [{ id: 140463, specId: 255 }],
  },
  IMPROVED_ASPECT_OF_THE_TURTLE_TALENT: {
    id: 1258485,
    name: 'Improved Aspect of the Turtle',
    icon: 'ability_hunter_pet_turtle',
    maxRanks: 1,
    entryIds: [126490],
    definitionIds: [{ id: 131316, specId: 255 }],
  },
  IMPROVED_FEIGN_DEATH_TALENT: {
    id: 1258486,
    name: 'Improved Feign Death',
    icon: 'ability_rogue_feigndeath',
    maxRanks: 2,
    entryIds: [135706],
    definitionIds: [{ id: 140461, specId: 255 }],
  },
  IMPROVED_SNARING_TALENT: {
    id: 1268868,
    name: 'Improved Snaring',
    icon: 'inv_fishing_nethooks01',
    maxRanks: 1,
    entryIds: [126478],
    definitionIds: [{ id: 131304, specId: 255 }],
  },
  IMPROVED_TRAPS_TALENT: {
    id: 343247,
    name: 'Improved Traps',
    icon: 'ability_hunter_traplauncher',
    maxRanks: 1,
    entryIds: [126483],
    definitionIds: [{ id: 131309, specId: 255 }],
  },
  IMPROVED_WILDFIRE_BOMB_TALENT: {
    id: 321290,
    name: 'Improved Wildfire Bomb',
    icon: 'inv_eng_bombfire',
    maxRanks: 2,
    entryIds: [126349],
    definitionIds: [{ id: 131175, specId: 255 }],
  },
  INCENDIARY_AMMUNITION_TALENT: {
    id: 471428,
    name: 'Incendiary Ammunition',
    icon: 'inv12_ability_hunter_fierymunitions',
    maxRanks: 1,
    entryIds: [132195],
    definitionIds: [{ id: 136996, specId: 254 }],
  },
  INTIMIDATION_MARKSMANSHIP_TALENT: {
    id: 474421,
    name: 'Intimidation',
    icon: 'artifactability_survivalhunter_eaglesbite',
    maxRanks: 1,
    entryIds: [128413],
    definitionIds: [{ id: 133219, specId: 254 }],
  },
  INTIMIDATION_SHARED_TALENT: {
    id: 19577,
    name: 'Intimidation',
    icon: 'ability_devour',
    maxRanks: 1,
    entryIds: [126461, 128412],
    definitionIds: [
      { id: 131287, specId: 253 },
      { id: 133218, specId: 255 },
    ],
  },
  INVIGORATING_PULSE_TALENT: {
    id: 450379,
    name: 'Invigorating Pulse',
    icon: 'ability_mage_netherwindpresence',
    maxRanks: 1,
    entryIds: [117568],
    definitionIds: [{ id: 122580, specId: 255 }],
  },
  JAGGED_WOUNDS_TALENT: {
    id: 1265044,
    name: 'Jagged Wounds',
    icon: 'ability_skeer_bloodletting',
    maxRanks: 1,
    entryIds: [126420],
    definitionIds: [{ id: 131246, specId: 253 }],
  },
  KEEN_EYESIGHT_TALENT: {
    id: 378004,
    name: 'Keen Eyesight',
    icon: 'ability_hunter_silenthunter',
    maxRanks: 2,
    entryIds: [126473],
    definitionIds: [{ id: 131299, specId: 255 }],
  },
  KILLER_COBRA_TALENT: {
    id: 199532,
    name: 'Killer Cobra',
    icon: 'ability_hunter_snaketrap',
    maxRanks: 1,
    entryIds: [126438],
    definitionIds: [{ id: 131264, specId: 253 }],
  },
  KILLER_COMPANION_TALENT: {
    id: 378955,
    name: 'Killer Companion',
    icon: 'ability_hunter_masterscall',
    maxRanks: 2,
    entryIds: [135503],
    definitionIds: [{ id: 140260, specId: 255 }],
  },
  KILLER_INSTINCT_TALENT: {
    id: 273887,
    name: 'Killer Instinct',
    icon: 'ability_hunter_killcommand',
    maxRanks: 2,
    entryIds: [126426],
    definitionIds: [{ id: 131252, specId: 253 }],
  },
  KILL_CLEAVE_TALENT: {
    id: 378207,
    name: 'Kill Cleave',
    icon: 'spell_druid_bloodythrash',
    maxRanks: 1,
    entryIds: [126417],
    definitionIds: [{ id: 131243, specId: 253 }],
  },
  KILL_COMMAND_BEAST_MASTERY_TALENT: {
    id: 34026,
    name: 'Kill Command',
    icon: 'ability_hunter_killcommand',
    maxRanks: 1,
    entryIds: [126408],
    definitionIds: [{ id: 131234, specId: 253 }],
    focusCost: 30,
  },
  KILL_COMMAND_SURVIVAL_TALENT: {
    id: 259489,
    name: 'Kill Command',
    icon: 'ability_hunter_killcommand',
    maxRanks: 1,
    entryIds: [126314],
    definitionIds: [{ id: 131140, specId: 255 }],
  },
  KILL_SHOT_TALENT: {
    id: 53351,
    name: 'Kill Shot',
    icon: 'ability_hunter_assassinate2',
    maxRanks: 1,
    entryIds: [135713],
    definitionIds: [{ id: 140468, specId: 254 }],
    focusCost: 10,
  },
  KINDLING_FLARE_TALENT: {
    id: 459506,
    name: 'Kindling Flare',
    icon: 'achievment_raid_houroftwilight',
    maxRanks: 1,
    entryIds: [126491],
    definitionIds: [{ id: 131317, specId: 255 }],
  },
  KODO_TRANQUILIZER_TALENT: {
    id: 459983,
    name: 'Kodo Tranquilizer',
    icon: 'ability_mount_kodo_03',
    maxRanks: 1,
    entryIds: [126480],
    definitionIds: [{ id: 131306, specId: 255 }],
  },
  LACERATION_TALENT: {
    id: 459552,
    name: 'Laceration',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [126432],
    definitionIds: [{ id: 131258, specId: 253 }],
  },
  LETHAL_BARBS_TALENT: {
    id: 1264781,
    name: 'Lethal Barbs',
    icon: 'ability_hunter_criticalshot',
    maxRanks: 1,
    entryIds: [136061],
    definitionIds: [{ id: 140816, specId: 255 }],
  },
  LETHAL_CALIBRATION_TALENT: {
    id: 1262409,
    name: 'Lethal Calibration',
    icon: 'ability_siege_engineer_detonate',
    maxRanks: 1,
    entryIds: [126316],
    definitionIds: [{ id: 131142, specId: 255 }],
  },
  LIGHT_AMMO_TALENT: {
    id: 378913,
    name: 'Light Ammo',
    icon: 'ships_ability_armorpiercingammo',
    maxRanks: 1,
    entryIds: [132192],
    definitionIds: [{ id: 136993, specId: 254 }],
  },
  LOCK_AND_LOAD_TALENT: {
    id: 194595,
    name: 'Lock and Load',
    icon: 'ability_hunter_lockandload',
    maxRanks: 1,
    entryIds: [132193],
    definitionIds: [{ id: 136994, specId: 254 }],
  },
  LONE_SURVIVOR_TALENT: {
    id: 388039,
    name: 'Lone Survivor',
    icon: 'ability_hunter_huntervswild',
    maxRanks: 1,
    entryIds: [126454],
    definitionIds: [{ id: 131280, specId: 255 }],
  },
  LUNAR_CALLING_TALENT: {
    id: 1253852,
    name: 'Lunar Calling',
    icon: 'ability_hunter_sentinelowl',
    maxRanks: 1,
    entryIds: [117562],
    definitionIds: [{ id: 122574, specId: 255 }],
  },
  LUNAR_STORM_TALENT: {
    id: 1253732,
    name: 'Lunar Storm',
    icon: 'artifactability_balancedruid_moonandstars',
    maxRanks: 1,
    entryIds: [117575],
    definitionIds: [{ id: 122587, specId: 255 }],
  },
  LUNGE_TALENT: {
    id: 378934,
    name: 'Lunge',
    icon: 'inv_polearm_2h_kultirasharpoon_a_01',
    maxRanks: 1,
    entryIds: [126332],
    definitionIds: [{ id: 131158, specId: 255 }],
  },
  MASTERFUL_CALL_TALENT: {
    id: 1268705,
    name: 'Masterful Call',
    icon: 'ability_hunter_masterscall',
    maxRanks: 1,
    entryIds: [123781],
    definitionIds: [{ id: 128619, specId: 255 }],
  },
  MASTER_HANDLER_TALENT: {
    id: 424558,
    name: 'Master Handler',
    icon: 'inv_leatherworking_70_petleash',
    maxRanks: 1,
    entryIds: [126421],
    definitionIds: [{ id: 131247, specId: 253 }],
  },
  MASTER_MARKSMAN_TALENT: {
    id: 260309,
    name: 'Master Marksman',
    icon: 'ability_hunter_mastermarksman',
    maxRanks: 1,
    entryIds: [128396],
    definitionIds: [{ id: 133202, specId: 254 }],
  },
  MISDIRECTION_TALENT: {
    id: 34477,
    name: 'Misdirection',
    icon: 'ability_hunter_misdirection',
    maxRanks: 1,
    entryIds: [126484],
    definitionIds: [{ id: 131310, specId: 255 }],
  },
  MOMENT_OF_OPPORTUNITY_TALENT: {
    id: 459488,
    name: 'Moment of Opportunity',
    icon: 'ability_karoz_leap',
    maxRanks: 1,
    entryIds: [136674],
    definitionIds: [{ id: 141446, specId: 255 }],
  },
  MONGOOSE_FURY_TALENT: {
    id: 1252708,
    name: 'Mongoose Fury',
    icon: 'ability_hunter_mongoosebite',
    maxRanks: 1,
    entryIds: [135501],
    definitionIds: [{ id: 140258, specId: 255 }],
  },
  MONGOOSE_ROUNDS_TALENT: {
    id: 1253945,
    name: 'Mongoose Rounds',
    icon: 'inv_ammo_bullet_08',
    maxRanks: 1,
    entryIds: [135507],
    definitionIds: [{ id: 140264, specId: 255 }],
  },
  MOONLIGHT_CHAKRAM_TALENT: {
    id: 1264902,
    name: 'Moonlight Chakram',
    icon: 'inv_ability_hunter_deathchakram',
    maxRanks: 1,
    entryIds: [136065],
    definitionIds: [{ id: 140820, specId: 255 }],
  },
  MOONS_BLESSING_TALENT: {
    id: 1253825,
    name: "Moon's Blessing",
    icon: 'spell_druid_lunarinspiration',
    maxRanks: 1,
    entryIds: [117570],
    definitionIds: [{ id: 122582, specId: 255 }],
  },
  MUZZLE_TALENT: {
    id: 187707,
    name: 'Muzzle',
    icon: 'ability_hunter_negate',
    maxRanks: 1,
    entryIds: [100543],
    definitionIds: [{ id: 105545, specId: 255 }],
  },
  NATURAL_MENDING_TALENT: {
    id: 270581,
    name: 'Natural Mending',
    icon: 'ability_hunter_onewithnature',
    maxRanks: 2,
    entryIds: [126465],
    definitionIds: [{ id: 131291, specId: 255 }],
  },
  NATURES_ALLY_1_BEAST_MASTERY_TALENT: {
    id: 1273043,
    name: "Nature's Ally",
    icon: 'inv12_apextalent_hunter_killfrenzy',
    maxRanks: 1,
    entryIds: [137052],
    definitionIds: [{ id: 141815, specId: 253 }],
  },
  NATURES_ALLY_2_BEAST_MASTERY_TALENT: {
    id: 1273065,
    name: "Nature's Ally",
    icon: 'ability_hunter_pathfinding2',
    maxRanks: 2,
    entryIds: [137051],
    definitionIds: [{ id: 141814, specId: 253 }],
  },
  NATURES_ALLY_3_BEAST_MASTERY_TALENT: {
    id: 1273126,
    name: "Nature's Ally",
    icon: 'ability_hunter_goforthethroat',
    maxRanks: 1,
    entryIds: [137050],
    definitionIds: [{ id: 141813, specId: 253 }],
  },
  NO_HARD_FEELINGS_TALENT: {
    id: 459546,
    name: 'No Hard Feelings',
    icon: 'ability_seal',
    maxRanks: 1,
    entryIds: [126476],
    definitionIds: [{ id: 131302, specId: 255 }],
  },
  NO_MERCY_TALENT: {
    id: 472660,
    name: 'No Mercy',
    icon: 'ability_hunter_goforthethroat',
    maxRanks: 1,
    entryIds: [117566],
    definitionIds: [{ id: 122578, specId: 255 }],
  },
  NO_SCOPE_TALENT: {
    id: 473385,
    name: 'No Scope',
    icon: 'inv_eng_crowsnestscope',
    maxRanks: 1,
    entryIds: [137375],
    definitionIds: [{ id: 142135, specId: 254 }],
  },
  OBSIDIAN_ARROWHEAD_TALENT: {
    id: 471350,
    name: 'Obsidian Arrowhead',
    icon: 'ability_theblackarrow',
    maxRanks: 1,
    entryIds: [128380],
    definitionIds: [{ id: 133186, specId: 254 }],
  },
  ON_TARGET_TALENT: {
    id: 471348,
    name: 'On Target',
    icon: 'ability_hunter_blindingshot',
    maxRanks: 1,
    entryIds: [128714],
    definitionIds: [{ id: 133516, specId: 254 }],
  },
  OPEN_FIRE_TALENT: {
    id: 1253807,
    name: 'Open Fire',
    icon: 'spell_fire_flare',
    maxRanks: 1,
    entryIds: [135589],
    definitionIds: [{ id: 140345, specId: 255 }],
  },
  OUTLAND_VENOM_TALENT: {
    id: 459939,
    name: 'Outland Venom',
    icon: 'ability_hunter_potentvenom',
    maxRanks: 1,
    entryIds: [135497],
    definitionIds: [{ id: 140254, specId: 255 }],
  },
  PACK_MENTALITY_TALENT: {
    id: 472358,
    name: 'Pack Mentality',
    icon: 'spell_hunter_lonewolf',
    maxRanks: 1,
    entryIds: [117582],
    definitionIds: [{ id: 122594, specId: 255 }],
  },
  PACK_TACTICS_TALENT: {
    id: 321014,
    name: 'Pack Tactics',
    icon: 'ability_hunter_invigeration',
    maxRanks: 1,
    entryIds: [126437],
    definitionIds: [{ id: 131263, specId: 253 }],
  },
  PACT_OF_THE_HOLLOW_TALENT: {
    id: 1264690,
    name: 'Pact of the Hollow',
    icon: 'ability_creature_cursed_03',
    maxRanks: 1,
    entryIds: [136057],
    definitionIds: [{ id: 140812, specId: 254 }],
  },
  PADDED_ARMOR_TALENT: {
    id: 459450,
    name: 'Padded Armor',
    icon: 'ability_rogue_plunderarmor',
    maxRanks: 1,
    entryIds: [126470],
    definitionIds: [{ id: 131296, specId: 255 }],
  },
  PATHFINDING_TALENT: {
    id: 378002,
    name: 'Pathfinding',
    icon: 'ability_hunter_displacement',
    maxRanks: 1,
    entryIds: [126468],
    definitionIds: [{ id: 131294, specId: 255 }],
  },
  PENETRATING_SHOTS_TALENT: {
    id: 459783,
    name: 'Penetrating Shots',
    icon: 'achievement_guildperk_reinforce_rank2',
    maxRanks: 1,
    entryIds: [128386],
    definitionIds: [{ id: 133192, specId: 254 }],
  },
  PIERCING_FANGS_TALENT: {
    id: 392053,
    name: 'Piercing Fangs',
    icon: 'inv_misc_monsterfang_02',
    maxRanks: 1,
    entryIds: [126434],
    definitionIds: [{ id: 131260, specId: 253 }],
  },
  POSTHASTE_TALENT: {
    id: 109215,
    name: 'Posthaste',
    icon: 'ability_hunter_posthaste',
    maxRanks: 1,
    entryIds: [126475],
    definitionIds: [{ id: 131301, specId: 255 }],
  },
  PRECISE_SHOTS_TALENT: {
    id: 260240,
    name: 'Precise Shots',
    icon: 'ability_hunter_snipertraining',
    maxRanks: 1,
    entryIds: [128399],
    definitionIds: [{ id: 133205, specId: 254 }],
  },
  PRECISION_DETONATION_TALENT: {
    id: 471369,
    name: 'Precision Detonation',
    icon: 'ability_hunter_explosiveshot',
    maxRanks: 1,
    entryIds: [137377],
    definitionIds: [{ id: 142137, specId: 254 }],
  },
  PRECISION_STRIKES_TALENT: {
    id: 1267003,
    name: 'Precision Strikes',
    icon: 'inv12_ability_hunter_rupturingblow',
    maxRanks: 1,
    entryIds: [126443],
    definitionIds: [{ id: 131269, specId: 255 }],
  },
  PRIMAL_SURGE_TALENT: {
    id: 1272154,
    name: 'Primal Surge',
    icon: 'ability_hunter_longevity',
    maxRanks: 1,
    entryIds: [136680],
    definitionIds: [{ id: 141452, specId: 255 }],
  },
  QUICK_DRAW_TALENT: {
    id: 459794,
    name: 'Quick Draw',
    icon: 'ability_rogue_pistolshot',
    maxRanks: 1,
    entryIds: [128397],
    definitionIds: [{ id: 133203, specId: 254 }],
  },
  QUICK_RELOAD_TALENT: {
    id: 1272136,
    name: 'Quick Reload',
    icon: 'ability_vehicle_reloadammo',
    maxRanks: 1,
    entryIds: [136683],
    definitionIds: [{ id: 141455, specId: 255 }],
  },
  RADIANT_EDGE_TALENT: {
    id: 1264903,
    name: 'Radiant Edge',
    icon: 'inv_misc_nightelfglaive',
    maxRanks: 1,
    entryIds: [136063],
    definitionIds: [{ id: 140818, specId: 255 }],
  },
  RAPID_FIRE_TALENT: {
    id: 257044,
    name: 'Rapid Fire',
    icon: 'ability_hunter_efficiency',
    maxRanks: 1,
    entryIds: [128383],
    definitionIds: [{ id: 133189, specId: 254 }],
  },
  RAPTOR_STRIKE_TALENT: {
    id: 186270,
    name: 'Raptor Strike',
    icon: 'ability_hunter_raptorstrike',
    maxRanks: 1,
    entryIds: [126322],
    definitionIds: [{ id: 131148, specId: 255 }],
    focusCost: 30,
  },
  RAPTOR_SWIPE_1_SURVIVAL_TALENT: {
    id: 1259003,
    name: 'Raptor Swipe',
    icon: 'inv12_apextalent_hunter_raptorswipe',
    maxRanks: 1,
    entryIds: [137055],
    definitionIds: [{ id: 141818, specId: 255 }],
  },
  RAPTOR_SWIPE_2_SURVIVAL_TALENT: {
    id: 1259017,
    name: 'Raptor Swipe',
    icon: 'ability_hunter_raptorstrike',
    maxRanks: 2,
    entryIds: [137054],
    definitionIds: [{ id: 141817, specId: 255 }],
  },
  RAPTOR_SWIPE_3_SURVIVAL_TALENT: {
    id: 1259019,
    name: 'Raptor Swipe',
    icon: 'inv_raptortravelform',
    maxRanks: 1,
    entryIds: [137053],
    definitionIds: [{ id: 141816, specId: 255 }],
  },
  REJUVENATING_WIND_TALENT: {
    id: 385539,
    name: 'Rejuvenating Wind',
    icon: 'ability_druid_galewinds',
    maxRanks: 1,
    entryIds: [126444],
    definitionIds: [{ id: 131270, specId: 255 }],
  },
  ROAR_OF_SACRIFICE_TALENT: {
    id: 53480,
    name: 'Roar of Sacrifice',
    icon: 'ability_hunter_fervor',
    maxRanks: 1,
    entryIds: [136686],
    definitionIds: [{ id: 141458, specId: 255 }],
  },
  SALVO_TALENT: {
    id: 400456,
    name: 'Salvo',
    icon: 'spell_hunter_exoticmunitions_incendiary',
    maxRanks: 1,
    entryIds: [128381],
    definitionIds: [{ id: 133187, specId: 254 }],
  },
  SANCTIFIED_ARMAMENTS_TALENT: {
    id: 1253831,
    name: 'Sanctified Armaments',
    icon: 'inv_polearm_2h_arakkoa_c_01',
    maxRanks: 1,
    entryIds: [117578],
    definitionIds: [{ id: 122590, specId: 255 }],
  },
  SAVAGERY_BEAST_MASTERY_TALENT: {
    id: 424557,
    name: 'Savagery',
    icon: 'spell_nature_protectionformnature',
    maxRanks: 1,
    entryIds: [126418],
    definitionIds: [{ id: 131244, specId: 253 }],
  },
  SAVAGERY_SURVIVAL_TALENT: {
    id: 1251790,
    name: 'Savagery',
    icon: 'ability_hunter_ferociousinspiration',
    maxRanks: 2,
    entryIds: [135511],
    definitionIds: [{ id: 140268, specId: 255 }],
  },
  SCARE_BEAST_TALENT: {
    id: 1513,
    name: 'Scare Beast',
    icon: 'ability_druid_cower',
    maxRanks: 1,
    entryIds: [135707],
    definitionIds: [{ id: 140462, specId: 255 }],
    focusCost: 25,
  },
  SCENT_OF_BLOOD_TALENT: {
    id: 193532,
    name: 'Scent of Blood',
    icon: 'spell_shadow_lifedrain',
    maxRanks: 1,
    entryIds: [126404],
    definitionIds: [{ id: 131230, specId: 253 }],
  },
  SCOUTS_INSTINCTS_TALENT: {
    id: 459455,
    name: "Scout's Instincts",
    icon: 'ability_rogue_sprint',
    maxRanks: 1,
    entryIds: [135705],
    definitionIds: [{ id: 140460, specId: 255 }],
  },
  SCOUTS_VIGIL_TALENT: {
    id: 1253892,
    name: "Scout's Vigil",
    icon: 'sha_ability_rogue_bloodyeye',
    maxRanks: 1,
    entryIds: [123870],
    definitionIds: [{ id: 128708, specId: 255 }],
  },
  SENTINEL_TALENT: {
    id: 1253599,
    name: 'Sentinel',
    icon: 'inv_ability_sentinelhunter_lunarstorm',
    maxRanks: 1,
    entryIds: [117573],
    definitionIds: [{ id: 122585, specId: 255 }],
  },
  SERPENTINE_STRIKES_TALENT: {
    id: 468701,
    name: 'Serpentine Strikes',
    icon: 'spell_nature_poisoncleansingtotem',
    maxRanks: 1,
    entryIds: [126435],
    definitionIds: [{ id: 131261, specId: 253 }],
  },
  SERRATED_TIPS_TALENT: {
    id: 459502,
    name: 'Serrated Tips',
    icon: 'inv_spear_01',
    maxRanks: 2,
    entryIds: [126447],
    definitionIds: [{ id: 131273, specId: 255 }],
  },
  SHADOW_DAGGER_TALENT: {
    id: 467741,
    name: 'Shadow Dagger',
    icon: 'ability_throw',
    maxRanks: 1,
    entryIds: [128219],
    definitionIds: [{ id: 133026, specId: 254 }],
  },
  SHARPENED_CLAWS_TALENT: {
    id: 472524,
    name: 'Sharpened Claws',
    icon: 'ability_druid_swipe',
    maxRanks: 1,
    entryIds: [128358],
    definitionIds: [{ id: 133164, specId: 255 }],
  },
  SHARPENED_FANGS_TALENT: {
    id: 1264775,
    name: 'Sharpened Fangs',
    icon: 'inv_misc_monsterfang_02',
    maxRanks: 1,
    entryIds: [136060],
    definitionIds: [{ id: 140815, specId: 255 }],
  },
  SHELLSHOCK_TALENT: {
    id: 1252931,
    name: 'Shellshock',
    icon: 'inv_10_engineering2_pvpflaregun_color1',
    maxRanks: 1,
    entryIds: [135510],
    definitionIds: [{ id: 140267, specId: 255 }],
  },
  SHELL_COVER_TALENT: {
    id: 472707,
    name: 'Shell Cover',
    icon: 'inv_babyturtle2',
    maxRanks: 1,
    entryIds: [117564],
    definitionIds: [{ id: 122576, specId: 255 }],
  },
  SHELL_WALL_TALENT: {
    id: 1267218,
    name: 'Shell Wall',
    icon: 'inv_cape_special_turtleshell_c_01',
    maxRanks: 1,
    entryIds: [136673],
    definitionIds: [{ id: 141445, specId: 255 }],
  },
  SHOWER_OF_BLOOD_TALENT: {
    id: 1253053,
    name: 'Shower of Blood',
    icon: 'spell_druid_bloodythrash',
    maxRanks: 2,
    entryIds: [135495],
    definitionIds: [{ id: 140252, specId: 255 }],
  },
  SHRAPNEL_BOMB_TALENT: {
    id: 1253172,
    name: 'Shrapnel Bomb',
    icon: 'inv_wildfirebomb_shrapnel',
    maxRanks: 1,
    entryIds: [135500],
    definitionIds: [{ id: 140257, specId: 255 }],
  },
  SHRAPNEL_SHOT_TALENT: {
    id: 473520,
    name: 'Shrapnel Shot',
    icon: 'spell_sandexplosion',
    maxRanks: 1,
    entryIds: [137376],
    definitionIds: [{ id: 142136, specId: 254 }],
  },
  SIC_EM_TALENT: {
    id: 1253137,
    name: "Sic 'Em",
    icon: 'ability_hunter_sickem',
    maxRanks: 1,
    entryIds: [135496],
    definitionIds: [{ id: 140253, specId: 255 }],
  },
  SLICKED_SHOES_TALENT: {
    id: 472719,
    name: 'Slicked Shoes',
    icon: 'ability_heroicleap',
    maxRanks: 1,
    entryIds: [117576],
    definitionIds: [{ id: 122588, specId: 255 }],
  },
  SMALL_GAME_HUNTER_TALENT: {
    id: 459802,
    name: 'Small Game Hunter',
    icon: 'inv_rabbit2_darkmoon',
    maxRanks: 1,
    entryIds: [128400],
    definitionIds: [{ id: 133206, specId: 254 }],
  },
  SMOKE_SCREEN_TALENT: {
    id: 430709,
    name: 'Smoke Screen',
    icon: 'spell_warlock_demonsoul',
    maxRanks: 1,
    entryIds: [123779],
    definitionIds: [{ id: 128617, specId: 254 }],
  },
  SNAKESKIN_QUIVER_TALENT: {
    id: 468695,
    name: 'Snakeskin Quiver',
    icon: 'inv_quiver_1h_hunter_c_01_green',
    maxRanks: 1,
    entryIds: [126406],
    definitionIds: [{ id: 131232, specId: 253 }],
  },
  SOLITARY_COMPANION_TALENT: {
    id: 474746,
    name: 'Solitary Companion',
    icon: 'ability_hunter_separationanxiety',
    maxRanks: 1,
    entryIds: [136678],
    definitionIds: [{ id: 141450, specId: 253 }],
  },
  SOUL_DRINKER_TALENT: {
    id: 469638,
    name: 'Soul Drinker',
    icon: 'ability_warlock_soulsiphon',
    maxRanks: 1,
    entryIds: [117565],
    definitionIds: [{ id: 122577, specId: 254 }],
  },
  SPECIALIZED_ARSENAL_TALENT: {
    id: 459542,
    name: 'Specialized Arsenal',
    icon: 'inv_misc_quiver_03',
    maxRanks: 1,
    entryIds: [126453],
    definitionIds: [{ id: 131279, specId: 255 }],
  },
  STALK_AND_STRIKE_TALENT: {
    id: 1266069,
    name: 'Stalk and Strike',
    icon: 'ability_ambush',
    maxRanks: 1,
    entryIds: [136521],
    definitionIds: [{ id: 141294, specId: 255 }],
  },
  STAMPEDE_TALENT: {
    id: 472741,
    name: 'Stampede!',
    icon: 'ability_hunter_bestialdiscipline',
    maxRanks: 1,
    entryIds: [117563],
    definitionIds: [{ id: 122575, specId: 255 }],
  },
  STARGAZER_TALENT: {
    id: 1253751,
    name: 'Stargazer',
    icon: 'icon_7fx_nightborn_astromancer_blue',
    maxRanks: 1,
    entryIds: [117555],
    definitionIds: [{ id: 122567, specId: 255 }],
  },
  STOMP_TALENT: {
    id: 199530,
    name: 'Stomp',
    icon: 'warrior_talent_icon_thunderstruck',
    maxRanks: 1,
    entryIds: [126409],
    definitionIds: [{ id: 131235, specId: 253 }],
  },
  STRIKE_AS_ONE_TALENT: {
    id: 1251717,
    name: 'Strike as One',
    icon: 'inv_coordinatedassault',
    maxRanks: 1,
    entryIds: [135512],
    definitionIds: [{ id: 140269, specId: 255 }],
  },
  SURGING_SHOTS_TALENT: {
    id: 391559,
    name: 'Surging Shots',
    icon: 'ability_hunter_resistanceisfutile',
    maxRanks: 1,
    entryIds: [128717],
    definitionIds: [{ id: 133519, specId: 254 }],
  },
  SURVIVAL_OF_THE_FITTEST_TALENT: {
    id: 264735,
    name: 'Survival of the Fittest',
    icon: 'spell_nature_spiritarmor',
    maxRanks: 1,
    entryIds: [126488],
    definitionIds: [{ id: 131314, specId: 255 }],
  },
  SWEEPING_SPEAR_TALENT: {
    id: 378950,
    name: 'Sweeping Spear',
    icon: 'spell_warrior_wildstrike',
    maxRanks: 2,
    entryIds: [135504],
    definitionIds: [{ id: 140261, specId: 255 }],
  },
  TAKEDOWN_TALENT: {
    id: 1250646,
    name: 'Takedown',
    icon: 'inv12_ability_hunter_takedown',
    maxRanks: 1,
    entryIds: [135514],
    definitionIds: [{ id: 140271, specId: 255 }],
  },
  TAKE_AIM_1_MARKSMANSHIP_TALENT: {
    id: 1273132,
    name: 'Take Aim',
    icon: 'inv12_apextalent_hunter_deadlyinsight',
    maxRanks: 1,
    entryIds: [137058],
    definitionIds: [{ id: 141821, specId: 254 }],
  },
  TAKE_AIM_2_MARKSMANSHIP_TALENT: {
    id: 1273129,
    name: 'Take Aim',
    icon: 'ability_hunter_wildquiver',
    maxRanks: 2,
    entryIds: [137057],
    definitionIds: [{ id: 141820, specId: 254 }],
  },
  TAKE_AIM_3_MARKSMANSHIP_TALENT: {
    id: 1273128,
    name: 'Take Aim',
    icon: 'inv_spear_07',
    maxRanks: 1,
    entryIds: [137056],
    definitionIds: [{ id: 141819, specId: 254 }],
  },
  TAR_COATED_BINDINGS_TALENT: {
    id: 459460,
    name: 'Tar-Coated Bindings',
    icon: 'inv_misc_food_legion_goooil_pool',
    maxRanks: 1,
    entryIds: [136671],
    definitionIds: [{ id: 141443, specId: 255 }],
  },
  TAR_TRAP_TALENT: {
    id: 187698,
    name: 'Tar Trap',
    icon: 'spell_yorsahj_bloodboil_black',
    maxRanks: 1,
    entryIds: [126457],
    definitionIds: [{ id: 131283, specId: 255 }],
  },
  TENACIOUS_TALENT: {
    id: 474456,
    name: 'Tenacious',
    icon: 'ability_druid_demoralizingroar',
    maxRanks: 1,
    entryIds: [128408],
    definitionIds: [{ id: 133214, specId: 254 }],
  },
  TENSILE_BOWSTRING_TALENT: {
    id: 471366,
    name: 'Tensile Bowstring',
    icon: 'inv_archaeology_70_tauren_stonewoodbow',
    maxRanks: 1,
    entryIds: [128388],
    definitionIds: [{ id: 133194, specId: 254 }],
  },
  TERRITORIAL_INSTINCTS_TALENT: {
    id: 459507,
    name: 'Territorial Instincts',
    icon: 'spell_nature_shamanrage',
    maxRanks: 1,
    entryIds: [126458],
    definitionIds: [{ id: 131284, specId: 255 }],
  },
  THE_BEAST_WITHIN_TALENT: {
    id: 231548,
    name: 'The Beast Within',
    icon: 'ability_druid_ferociousbite',
    maxRanks: 1,
    entryIds: [126436],
    definitionIds: [{ id: 131262, specId: 253 }],
  },
  THE_BELL_TOLLS_TALENT: {
    id: 467644,
    name: 'The Bell Tolls',
    icon: 'spell_shadow_animatedead',
    maxRanks: 1,
    entryIds: [136231],
    definitionIds: [{ id: 141004, specId: 254 }],
  },
  THRILL_OF_THE_HUNT_TALENT: {
    id: 1265051,
    name: 'Thrill of the Hunt',
    icon: 'ability_hunter_thrillofthehunt',
    maxRanks: 2,
    entryIds: [126407],
    definitionIds: [{ id: 131233, specId: 253 }],
  },
  THROUGH_THE_EYES_TALENT: {
    id: 1277565,
    name: 'Through the Eyes',
    icon: 'ability_cheapshot',
    maxRanks: 1,
    entryIds: [136742],
    definitionIds: [{ id: 141514, specId: 254 }],
  },
  THUNDERING_HOOVES_TALENT: {
    id: 459693,
    name: 'Thundering Hooves',
    icon: 'inv__blacksmithing_hoofplate',
    maxRanks: 1,
    entryIds: [126433],
    definitionIds: [{ id: 131259, specId: 253 }],
  },
  TIP_OF_THE_SPEAR_TALENT: {
    id: 260285,
    name: 'Tip of the Spear',
    icon: 'ability_bossmannoroth_glaivethrust',
    maxRanks: 1,
    entryIds: [126323],
    definitionIds: [{ id: 131149, specId: 255 }],
  },
  TOUCH_OF_GRASS_TALENT: {
    id: 1258402,
    name: 'Touch of Grass',
    icon: 'inv12_ability_druid_lifetreading',
    maxRanks: 2,
    entryIds: [135710],
    definitionIds: [{ id: 140465, specId: 255 }],
  },
  TRAILBLAZER_TALENT: {
    id: 199921,
    name: 'Trailblazer',
    icon: 'ability_hunter_aspectmastery',
    maxRanks: 1,
    entryIds: [136675],
    definitionIds: [{ id: 141447, specId: 255 }],
  },
  TRAINING_EXPERT_TALENT: {
    id: 378209,
    name: 'Training Expert',
    icon: 'spell_hunter_adaptation',
    maxRanks: 2,
    entryIds: [126399],
    definitionIds: [{ id: 131225, specId: 253 }],
  },
  TRANQUILIZING_SHOT_TALENT: {
    id: 19801,
    name: 'Tranquilizing Shot',
    icon: 'spell_nature_drowsy',
    maxRanks: 1,
    entryIds: [135712],
    definitionIds: [{ id: 140467, specId: 255 }],
  },
  TRICK_SHOTS_TALENT: {
    id: 257621,
    name: 'Trick Shots',
    icon: 'inv_trickshot',
    maxRanks: 1,
    entryIds: [128378],
    definitionIds: [{ id: 133184, specId: 254 }],
  },
  TRIGGER_FINGER_TALENT: {
    id: 459534,
    name: 'Trigger Finger',
    icon: 'inv_10_engineering2_pvpflaregun_color1',
    maxRanks: 2,
    entryIds: [126460],
    definitionIds: [{ id: 131286, specId: 255 }],
  },
  TRUESHOT_TALENT: {
    id: 288613,
    name: 'Trueshot',
    icon: 'ability_trueshot',
    maxRanks: 1,
    entryIds: [128367],
    definitionIds: [{ id: 133173, specId: 254 }],
  },
  TWILIGHT_REQUIEM_TALENT: {
    id: 1264904,
    name: 'Twilight Requiem',
    icon: 'spell_nature_moonglow',
    maxRanks: 1,
    entryIds: [136522],
    definitionIds: [{ id: 141295, specId: 255 }],
  },
  TWIN_FANGS_TALENT: {
    id: 1272139,
    name: 'Twin Fangs',
    icon: 'ability_hunter_spearhead',
    maxRanks: 1,
    entryIds: [135689],
    definitionIds: [{ id: 140445, specId: 255 }],
  },
  TWO_AGAINST_MANY_TALENT: {
    id: 1251718,
    name: 'Two Against Many',
    icon: 'ability_hunter_separationanxiety',
    maxRanks: 1,
    entryIds: [136684],
    definitionIds: [{ id: 141456, specId: 255 }],
  },
  UMBRAL_REACH_TALENT: {
    id: 1235397,
    name: 'Umbral Reach',
    icon: 'spell_deathknight_strangulate',
    maxRanks: 1,
    entryIds: [132888],
    definitionIds: [{ id: 137674, specId: 254 }],
  },
  UNBREAKABLE_BOND_TALENT: {
    id: 1223323,
    name: 'Unbreakable Bond',
    icon: 'ability_hunter_separationanxiety',
    maxRanks: 1,
    entryIds: [129619],
    definitionIds: [{ id: 134420, specId: 254 }],
  },
  UNERRING_VISION_TALENT: {
    id: 474738,
    name: 'Unerring Vision',
    icon: 'spell_hunter_exoticmunitions_frozen',
    maxRanks: 1,
    entryIds: [132194],
    definitionIds: [{ id: 136995, specId: 254 }],
  },
  UNLOAD_TALENT: {
    id: 1277548,
    name: 'Unload',
    icon: 'ability_hunter_efficiency_brown',
    maxRanks: 1,
    entryIds: [128609],
    definitionIds: [{ id: 133412, specId: 254 }],
  },
  UNMATCHED_PRECISION_TALENT: {
    id: 1232955,
    name: 'Unmatched Precision',
    icon: 'hunter_pvp_snipershot',
    maxRanks: 2,
    entryIds: [128370],
    definitionIds: [{ id: 133176, specId: 254 }],
  },
  UNNATURAL_CAUSES_TALENT: {
    id: 459527,
    name: 'Unnatural Causes',
    icon: 'ability_hunter_potentvenom',
    maxRanks: 1,
    entryIds: [126450],
    definitionIds: [{ id: 131276, specId: 255 }],
  },
  URSINE_FURY_TALENT: {
    id: 472476,
    name: 'Ursine Fury',
    icon: 'spell_druid_bearhug',
    maxRanks: 1,
    entryIds: [117569],
    definitionIds: [{ id: 122581, specId: 255 }],
  },
  VOLLEY_TALENT: {
    id: 260243,
    name: 'Volley',
    icon: 'ability_hunter_rapidkilling',
    maxRanks: 1,
    entryIds: [128376],
    definitionIds: [{ id: 133182, specId: 254 }],
  },
  VULNERABILITY_TALENT: {
    id: 1257011,
    name: 'Vulnerability',
    icon: 'ability_rogue_findweakness',
    maxRanks: 1,
    entryIds: [126342],
    definitionIds: [{ id: 131168, specId: 255 }],
  },
  WAILING_DEAD_TALENT: {
    id: 1264290,
    name: 'Wailing Dead',
    icon: 'ability_deathknight_summongargoyle',
    maxRanks: 1,
    entryIds: [136058],
    definitionIds: [{ id: 140813, specId: 254 }],
  },
  WALLOP_TALENT: {
    id: 1252738,
    name: 'Wallop',
    icon: 'ability_butcher_heavyhanded',
    maxRanks: 1,
    entryIds: [136144],
    definitionIds: [{ id: 140899, specId: 255 }],
  },
  WAR_ORDERS_TALENT: {
    id: 393933,
    name: 'War Orders',
    icon: 'ability_hunter_barbedshot',
    maxRanks: 1,
    entryIds: [126405],
    definitionIds: [{ id: 131231, specId: 253 }],
  },
  WILDERNESS_MEDICINE_TALENT: {
    id: 343242,
    name: 'Wilderness Medicine',
    icon: 'ability_hunter_mendpet',
    maxRanks: 1,
    entryIds: [126446],
    definitionIds: [{ id: 131272, specId: 255 }],
  },
  WILDFIRE_BOMB_TALENT: {
    id: 259495,
    name: 'Wildfire Bomb',
    icon: 'inv_wildfirebomb',
    maxRanks: 1,
    entryIds: [126324],
    definitionIds: [{ id: 131150, specId: 255 }],
    focusCost: 10,
  },
  WILDFIRE_IMBUEMENT_TALENT: {
    id: 1252943,
    name: 'Wildfire Imbuement',
    icon: 'spell_shaman_improvelavalash',
    maxRanks: 1,
    entryIds: [136681],
    definitionIds: [{ id: 141453, specId: 255 }],
  },
  WILDFIRE_INFUSION_TALENT: {
    id: 460198,
    name: 'Wildfire Infusion',
    icon: 'inv_misc_5potionbag_special',
    maxRanks: 1,
    entryIds: [126328],
    definitionIds: [{ id: 131154, specId: 255 }],
  },
  WILDFIRE_SHELLS_TALENT: {
    id: 1261229,
    name: 'Wildfire Shells',
    icon: 'inv_ammo_firetar',
    maxRanks: 1,
    entryIds: [136066],
    definitionIds: [{ id: 140821, specId: 255 }],
  },
  WILDSPEAKER_TALENT: {
    id: 1232739,
    name: 'Wildspeaker',
    icon: 'ability_hunter_huntingparty',
    maxRanks: 1,
    entryIds: [132188],
    definitionIds: [{ id: 136989, specId: 253 }],
  },
  WILD_INSTINCTS_TALENT: {
    id: 378442,
    name: 'Wild Instincts',
    icon: 'ability_hunter_beastwithin',
    maxRanks: 1,
    entryIds: [126401],
    definitionIds: [{ id: 131227, specId: 253 }],
  },
  WILD_THRASH_TALENT: {
    id: 1264359,
    name: 'Wild Thrash',
    icon: 'ability_hunter_sickem',
    maxRanks: 1,
    entryIds: [126425],
    definitionIds: [{ id: 131251, specId: 253 }],
    focusCost: 35,
  },
  WINDRUNNER_QUIVER_TALENT: {
    id: 473523,
    name: 'Windrunner Quiver',
    icon: 'inv_quiver_1h_hunter_c_01_green',
    maxRanks: 1,
    entryIds: [128372],
    definitionIds: [{ id: 133178, specId: 254 }],
  },
  WITHERING_FIRE_TALENT: {
    id: 466990,
    name: 'Withering Fire',
    icon: 'spell_shadow_painspike',
    maxRanks: 1,
    entryIds: [117590],
    definitionIds: [{ id: 122602, specId: 254 }],
  },
  WYVERNS_GAZE_TALENT: {
    id: 1264792,
    name: "Wyvern's Gaze",
    icon: 'ability_deathwing_assualtaspects',
    maxRanks: 1,
    entryIds: [136236],
    definitionIds: [{ id: 141009, specId: 255 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_HUNTER };
